export default __webpack_public_path__ + "static/media/flag-greenland.ef39be65.svg";